import http from '../../http-common';

/**
 * @author André
 * 09/08/2022
 **/

const url = '/Autocomplete/';

export const DefaultAutocompleteService = {
    GetProfileListAutoComplete() {
        return http.get(`${url}Profile`)
    },
    GetMenuAutocomplete(data) {
        return http.post(`${url}Menu`, data)
    },
    GetSystemParameterListAutoComplete() {
        return http.get(`${url}SystemParameter`)
    },
    GetCountryAutocomplete() {
        return http.get(`${url}Country`)
    },
    GetStateAutocomplete() {
        return http.get(`${url}State`)
    },
    GetCityAutocomplete() {
        return http.get(`${url}City`)
    },
    GetUserAutocomplete() {
        return http.get(`${url}User`)
    },
    GetStoreAutocomplete() {
        return http.get(`${url}Store`)
    },
    GetInventoryStockLocation() {
        return http.get(`${url}StockLocationDescriptionList`)
    },
    GetSeparatorFileTemplate() {
        return http.get(`${url}SeparatorFileTemplate`)
    },
    GetClient() {
        return http.get(`${url}Client`)
    },
    GetColumnName() {
        return http.get(`${url}ColumnName`)
    },
    GetLocationStock(data) {
        return http.post(`${url}LocationStock`, data)
    },
    GetCollector(data) {
        return http.get(`${url}GetCollector`, data)
    },
    GetProductGroupListAutoComplete(data) {
        return http.get(`${url}ProductGroup`, data)
    },
    
};
